module.exports = __webpack_public_path__ + "df03615b8306b23953473ec0bddd793b.png";